import { ChannelUnsubscribe, channelClient, RequestPolicies } from 'shared/channels';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { tokenContract } from './tokenContract';
import type { TokenAnswer, TokenPayload } from './tokenModel';

/** The worker's access to the token, which only a page can get. */
export const tokenClient = {
  /**
   * Asks the open pages for a token. Rejects with
   * `ChannelRequestNotAcknowledgedError` when no page serves the contract.
   */
  requestToken(): Promise<TokenAnswer> {
    return channelClient.request(tokenContract, 'getToken', undefined, RequestPolicies.pageAnswer);
  },

  onTokenPush(handler: (token: Partial<TokenPayload>) => void): ChannelUnsubscribe {
    return channelClient.onEventOfType(tokenContract, DomainMessagesTypes.tokenPush, (event) => handler(event.data ?? {}));
  },
};
